import { lazy } from "react";
export const AdminCommentReports = lazy(() =>
  import("../pages/safety/admin-comment-reports.js").then((module) => ({
    default: module.AdminCommentReports,
  })),
);
export const UsageSummaryPanel = lazy(() =>
  import("../pages/engagement/usage-summary-panel.js").then((module) => ({
    default: module.UsageSummaryPanel,
  })),
);

export const RoundDetailDialog = lazy(() =>
  import("../pages/rounds/round-detail-dialog.js").then((module) => ({
    default: module.RoundDetailDialog,
  })),
);
export const ProfileCardOverlay = lazy(() =>
  import("../pages/profile/profile-card-overlay.js").then((module) => ({
    default: module.ProfileCardOverlay,
  })),
);
export const AddRivalDialog = lazy(() =>
  import("../pages/rivalry/add-rival-dialog.js").then((module) => ({
    default: module.AddRivalDialog,
  })),
);
export const RivalryProfileOverlay = lazy(() =>
  import("../pages/rivalry/rivalry-profile-overlay.js").then((module) => ({
    default: module.RivalryProfileOverlay,
  })),
);
export const AdminCorrectionsPage = lazy(() =>
  import("../pages/rounds/admin-corrections-page.js").then((module) => ({
    default: module.AdminCorrectionsPage,
  })),
);
